import React, { useState } from 'react'
import { CButton, CFormInput } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { icon } from '../../../shared/icons'
import { useBostonState, emit } from '../lib/useBoston'
import { ensureGateway } from '../lib/gateway'
import { COMMANDS } from '../lib/catalogs'

/* Port fiel de viewConsole/bindConsole de boston_ia:
   enviar comandos GDS sueltos contra Sabre via gateway + catalogo de comandos. */
function ConsoleView() {
  const state = useBostonState()
  const [input, setInput] = useState(state.consoleInput || '')
  const categories = [...new Set(COMMANDS.map((c) => c.c))].sort()

  async function send(raw) {
    const cmd = (raw ?? input).trim()
    if (!cmd) return
    state.consoleInput = ''
    setInput('')
    state.consoleHistory.push({ command: cmd, success: false, responseText: 'Enviando...', durationMs: 0 })
    emit()
    const r = await ensureGateway().executeCommand(cmd)
    state.consoleHistory.pop()
    state.consoleHistory.push(r)
    emit()
  }

  function pick(cmd) {
    setInput(cmd)
    state.consoleInput = cmd
  }

  return (
    <>
      <div className="page-head">
        <div>
          <h1>Consola GDS</h1>
          <p>
            Probar comandos sueltos contra Sabre. Cada llamada usa el backend Boston (<code>/sabre/executeCommand</code>) con el
            token de sesion activo.
          </p>
        </div>
      </div>

      <div className="bia-grid-2asym">
        <div>
          <div className="card-x">
            <h3>Enviar comando</h3>
            <div className="bia-row-input">
              <CFormInput
                className="bia-mono"
                placeholder="*A · 130JUNBAHPAR · ER"
                value={input}
                onChange={(event) => {
                  setInput(event.target.value)
                  state.consoleInput = event.target.value
                }}
                onKeyDown={(event) => event.key === 'Enter' && send()}
              />
              <CButton color="success" className="btn-brand" onClick={() => send()}>
                <CIcon icon={icon('cilSend')} /> Enviar
              </CButton>
            </div>
          </div>

          <div className="card-x">
            <div className="bia-card-head">
              <h3>Historial</h3>
              <span className="bia-pill">{state.consoleHistory.length}</span>
            </div>
            {state.consoleHistory.length ? (
              <div className="bia-log">
                {state.consoleHistory
                  .slice()
                  .reverse()
                  .map((r, i) => (
                    <div key={i} className={`bia-log-row ${r.success ? 'ok' : 'err'}`}>
                      <div className="bia-log-meta">
                        <span className="bia-log-cmd">{r.command}</span>
                        <span className="bia-log-time">{r.durationMs} ms</span>
                      </div>
                      <pre>{String(r.responseText || '').slice(0, 1200)}</pre>
                    </div>
                  ))}
              </div>
            ) : (
              <p className="bia-empty">Sin comandos ejecutados todavia.</p>
            )}
          </div>
        </div>

        <div className="card-x bia-scroll" style={{ maxHeight: 680 }}>
          <h3>Catalogo de comandos</h3>
          {categories.map((cat) => (
            <details key={cat} className="bia-cat">
              <summary>
                {cat} <span className="bia-pill mini">{COMMANDS.filter((x) => x.c === cat).length}</span>
              </summary>
              <ul>
                {COMMANDS.filter((x) => x.c === cat).map((cmd) => (
                  <li key={cmd.cmd} onClick={() => pick(cmd.cmd)} title="Usar este comando">
                    <code>{cmd.cmd}</code>
                    <span>{cmd.m}</span>
                  </li>
                ))}
              </ul>
            </details>
          ))}
        </div>
      </div>
    </>
  )
}

export default ConsoleView
